import redBackground from "../assets/backgrounds/casino-red.webp";
import greenBackground from "../assets/backgrounds/casino-green.webp";

export const getCasinoBackground = (salaId) =>
  String(salaId) === "332" ? greenBackground : redBackground;
